import type { SourceOfFundsData } from '@onramp/state/types/SourceOfFundsData';

export const is3ds = (sof: SourceOfFundsData | undefined) => Boolean(sof?.cardInfo?.use3ds);
